import React, { Component } from 'react';
import { Row, Col, Card, Divider, Form, Input, Button, Select, Popover, Icon, Modal } from 'antd';
import { validate } from 'utils/registration/formUtils';
import { FormField, buildStateSelection } from 'utils/registration/formUtils';
import { ssFormUtils, ssFormValidationUtils } from '@bit/ui-common.ui-components/ss-utils';
import { fsdoRegConfig } from '../../forms/registration/formConfig';

const
config = fsdoRegConfig,
{ key } = config,
{ generateInitState, generateFormItem, generateInputComponent, generateOptionFromCommonData, generateStateOptionsFromCommonData, setMaxWidth } = ssFormUtils;

let dropdowns = {
    fsdo: false,
    fsdoStates: false
};

export default class FsdoOfficeInformation extends Component {
    constructor(props) {
        super(props);
        this.buildStateSelection = buildStateSelection.bind(this);
    }

    loadStates(prev) {
        const
        pgl = prev.geo.loading,
        cgl = this.props.geo.loading,
        { fsdoState } = this.props.fsdo.fsdoInfo.forms,
        { fsdoUpdateStateSelectOptions } = this.props.services;
        if(pgl && !cgl) {
            this.buildStateSelection(
                'United States Of America',
                fsdoState,
                fsdoUpdateStateSelectOptions
            );
            dropdowns.fsdoStates = true;
        }
    }

    loadFsdos(prev) {
        const
        pfr = prev.fsdo.fsdoInfo.fsdoRequest.status,
        cfr = this.props.fsdo.fsdoInfo.fsdoRequest.status,
        cfl = this.props.fsdo.fsdoInfo.fsdoLoaded,
        { fsdoLoadFsdoLocations, fsdoUpdateStateSelectOptions, fsdoLoadRequestReset } = this.props.services;
        if(pfr == null && cfr == null) fsdoLoadFsdoLocations();
        else if(cfl) {
            switch(cfr) {
                case 'success':
                    let result = [];
                    const { forms, fsdoLocations } = this.props.fsdo.fsdoInfo;
                    for(let i=0; i < fsdoLocations.length; i++) {
                        result.push(
                            <Select.Option key={i} value={fsdoLocations[i].name}>
                                {fsdoLocations[i].name}
                            </Select.Option>
                        );
                    }
                    fsdoLoadRequestReset();
                    // fsdoUpdateStateSelectOptions(
                    //     new FormField({...forms.fsdo,
                    //         options: result
                    //     })
                    // );
                    dropdowns.fsdo = true;
                    break;
            }
        }
    }

    componentDidUpdate(prevProps) {
        //if(!dropdowns.fsdoStates) this.loadStates(prevProps);
        if(!dropdowns.fsdo) this.loadFsdos(prevProps);
    }

    componentDidMount() {
        const { fsdoLoadFsdoLocations } = this.props.services;
        fsdoLoadFsdoLocations();
    }

    render() {
        const
        { fsdo, services, registrationForm, commonData } = this.props,
        { fsdoSubmit, storeFormField, storeForm } = services,
        { fsdoInfo } = fsdo,
        f = fsdoInfo.forms,
        form = registrationForm[key];

        let locations = fsdoInfo.fsdoLocations === null ? []: fsdoInfo.fsdoLocations.filter(fsdo => fsdo.viewable == true);
        let fsdoStates = commonData === undefined ? '' : generateStateOptionsFromCommonData(commonData.geoData.geoDataStore, 'USA');

        return (
            <div style={{ position: 'fixed', zIndex:2, textAlign: 'center', top: '58%', width: '100%' }}>
                <div style={{ textAlign: 'left' }}>
                    <Row type='flex' justify='center'>
                        <Col span={23}>
                            <Divider>
                                <span style={{
                                    color: 'rgb(53, 158, 255)',
                                    fontSize: '12px',
                                    fontWeight: 'bold',
                                    fontStyle: 'italic'
                                }}>
                                    {'Please select the Flight Standards District Office (FSDO)'}
                                </span>
                            </Divider>
                        </Col>
                    </Row>
                    <Row type='flex' justify='center' style={{ marginTop: '-14px' }}>
                        <Col span={23}>
                            <Row type='flex' justify='center' gutter={12}>
                                <Col span={5}>
                                    <Form.Item {...generateFormItem('fsdo', config, form)}>
                                        <Select {...{...generateInputComponent('fsdo', config, true, form, storeFormField, storeForm), optionFilterProp:'children', style: { width: '100%' }}}>
                                            {locations.length <= 0 ? null : locations.map(d => (
                                                    <Select.Option key={d.id} value={d.name}>
                                                        {d.name}
                                                    </Select.Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col span={5}>
                                    <Form.Item {...generateFormItem('fsdoState', config, form)}>
                                        <Select {...{...generateInputComponent('fsdoState', config, true, form, storeFormField, storeForm), optionFilterProp:'children', style: { width: '100%' }}}>
                                            { fsdoStates }
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>
            </div>
        );
    }
}
